import React, { useCallback, useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom"
import { Text } from "../../../../components/fields";
import { withGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useDispatch } from "react-redux";
import { redirectToSubLink } from "../../../../components/subdomainLink";
import { logIn, loginWithGoogle, getSelfUser, resendValidate } from "services/auth/actions";
import { toastAlert } from "@paylixecommerce/shared/components";
import { useFormik } from "formik";
import useAuthCookies from "../../../../hooks/useAuthCookies";
import * as Yup from "yup";
import { Button, Spin2 } from "components";
import Timer from "../../timer";
import { GoogleLogin } from '@react-oauth/google';
import { MagicLinkIcon } from "../magic-link";

import img from "../sign-up/img.svg";

import "../../index.scss";


export const Message = ({ text, isError }) => <div className={`${(!isError) ? "auth-confirm" : "auth-error"} message`}>
	<div>
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M10 6.66675H10.0083" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M9.16602 10H9.99935V13.3333H10.8327" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		</svg>
		{isError ? 'Info' : 'Info'}
	</div>
	{text}
</div>;


const LogIn = ({ googleReCaptchaProps: { executeRecaptcha }, isGoogleReady, isGoogleError }) => {

	const [sending, setSending] = useState(false);
	const [timer, setTimer] = useState(false);

	const { state } = useLocation();
	const history = useHistory();
	const dispatch = useDispatch();
	const { setCookies } = useAuthCookies();
	let message = null;
	const initialValues = {email: '', password: ''};
	const validationSchema = Yup.object().shape({
		email: Yup.string().required('Email or username is required'),
		password: Yup.string().required("Password is required")
	});

	useEffect(() => {

		if (state) {
			if (state.success === false) {
				toastAlert('error', state.message);
				return
			}
			if (state.code) {
				toastAlert('success', state.message);
				return
			}
			if (state.code === false) {
				toastAlert('error', state.message);
				return
			}
		}
	}, [state]);


	const parseJwt = (token) => {
		const base64Url = token.split('.')[1];
		const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
		const jsonPayload = decodeURIComponent(
			window.atob(base64).split('')
				.map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
				.join('')
		);
		return JSON.parse(jsonPayload);
	}

	const signIn = useCallback((credential) => {

		dispatch(loginWithGoogle({ id_token: credential, version: "v2" }))
			.then(({ data, status }) => {

				let parsed = parseJwt(credential);

				if (status === 202) {

					setCookies(data.token);

					if (data.type === 'email') {
						history.push({ pathname: '/email', state: { email: parsed ? parsed.email : "" } })
					} else if (data.type === 'otp') {
						history.push({ pathname: '/otp' });
					}

				} else if (status === 200) {

					setCookies(data.token);

					dispatch(getSelfUser())
						.then(() => redirectToSubLink('dashboard', '/', history))
						.catch((e) => console.error(e));
				}

			})

	}, [history]);

	const makeCaptcha = () => executeRecaptcha('logIn');

	const onSubmit = (values) => {
		makeCaptcha()
			.then((captcha) => {
				values.captcha = captcha;

				setSending(true);
				dispatch(logIn(values))
					.then(({ status, data }) => {

						if (status === 202) {

							setCookies(data.token);

							if (data.type === 'email') {
								history.push({ pathname: '/email', state: { email: values.email } })
							} else if (data.type === 'otp') {
								history.push('/otp')
							}

						} else if (status === 200) {

							setCookies(data.token);

							dispatch(getSelfUser())
								.then(() =>
									redirectToSubLink('dashboard', '/', history)
								);
						}

					})
					.catch(err => {
						let errMsg = '';

						if(err && err.status === 403) {
							toastAlert('error', err ? err.error : "");
						} else if (err && err.status === 400 && err.error === "Email Not Validated.") {
							toastAlert('warning', 'Please verify your email address before logging in. Check your inbox for the verification link.');
							history.push({ pathname: '/login', state: { success: true, email: values.email }})
						} else {
							errMsg = err ? err.error ? err.error : 'Invalid Email or Password. Please try again.' : 'Invalid Email or Password. Please try again.'
							toastAlert('error', errMsg);
						}
					})
					.finally(() => setSending(false))
			})

	}

	const onResendValidate = () => {

		setTimer(true)

		dispatch(resendValidate({ email: state.email }))
			.then(({ status, error }) => {
				if(status === 200) {
					if(state.message) {
						toastAlert('success', <span>Validation Email Resent to: <strong>{state.email}</strong></span>);
					}
				} else {
					toastAlert('error', error);
				}
			})
			.catch((err) => {
				toastAlert('error', err ? err.error : "");
			})
	}

	const form = useFormik({ initialValues, onSubmit, validationSchema });

	if (state) {
		if (state.success)
			message = <span>
	                A message with a confirmation link has been sent to your email address. Please follow the link to activate your account.<br/>
	                <span>Haven't received the email?<Timer onClick={onResendValidate} timer={timer} clearTimer={() => setTimer(false)}/>.</span>
				</span>;
		if (state.code)
			message = <span>Your email address has been successfully confirmed!</span>
	}

	const responseMessage = (response) => {
		signIn(response.credential);
	};
	const errorMessage = (error) => {
		console.log(error);
	};

	return <>
		<div className="auth-content">
			<Link to="/login" className="auth-content-logo" style={{ marginBottom: '2.5rem', marginTop: '-1.5rem' }}>
				<img loading="lazy" src="https://cdn.paylix.gg/static/images/images/logo_logo.svg" alt="Paylix Logo" style={{ width: 160, height: "auto" }} />
			</Link>

			<form onSubmit={form.handleSubmit} className="auth-content-form">

				<div className="auth-content-title">{
					(state && state.isSignUp) ? "You're almost all set" : "Welcome Back!"
				}</div>
				<span className="auth-content-details">
					{(state && state.isSignUp) ?
						"There is only one last step to confirm your registration" :
						"Please sign in below to continue into your Paylix Dashboard."
					}
				</span>

				{message && <Message isError={!(state && (state.success || state.code))} text={message} />}

				{/*
				  // Google Sign-In temporarily disabled
				  {isGoogleError || !isGoogleReady ? null : <>
				    <div className="auth-content-google">
				      <GoogleLogin
				        onSuccess={responseMessage}
				        onError={errorMessage}
				        shape="rectangular"
				        // width={230}
				      />
				    </div>
				    <div className="auth-content-line">
				      <span>or</span>
				    </div>
				  </>}
				*/}

				<Text autoComplete="on" label="Email / Username" name="email" {...form} />

				<Text name="password" type="password" label={<div className="w-100 d-flex justify-content-between">
					<div>Password</div>
					<Link to="/password/reset" className="forgot-password">
						Forgot Password?
					</Link>
				</div>} {...form} showPassword />

				<Button className="w-100" size="large" type="submit">
					{sending ? <Spin2 /> : null}
					<span style={{ display: sending ? 'none' : 'inline' }}>
						Sign In
					</span>
				</Button>

				<span className="auth-content-subfooter" style={{ marginTop: "1.5rem", marginBottom: "-0.5rem" }}>
					<div>You can also <Link to="/magic-link" style={{ fontWeight: 500 }}><MagicLinkIcon purple />&nbsp;Sign in with Magic Link</Link></div>
				</span>

			</form>
		</div>
		<span className="auth-content-subfooter">
			<div>Don't have an account? <Link to="/register">Sign up</Link></div>
		</span>
	</>
}

export default withGoogleReCaptcha(LogIn)
